import { Loading } from '@1trading/react/components/ui/index';

import { PageCard, PageCardContent } from './page-card';

const LoadingCard = () => {
  return (
    <PageCard size="lg" bordered>
      <PageCardContent className="pt-8">
        <Loading variant="primary" />
      </PageCardContent>
    </PageCard>
  );
};
LoadingCard.displayName = 'LoadingCard';

export default LoadingCard;
